export default (value, len) =>
  value !== undefined
    ? value instanceof Number
      ? value >= len
      : value.length >= len
    : true
